import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../shared/services/user.service';
import { ActivatedRoute } from '@angular/router';
import { REDCRSS_EVENTS } from '../../shared/services/constants/redcross_evemts';
import { LogService } from '../../shared/services/log.service';
import { ToastService } from '../../shared/services/toastr.service';
import { RedirectService } from '../../shared/services/redirect.service';
import { Store } from '@ngrx/store';
import { SignupState } from '../signup_state';
import { PasswordUpdaterBaseComponent } from '../shared/change_password/password_updater_base.component';
import { AnalyticsTrackingProvider, AuthService } from '@yotpo-ui/core';
import { StorageService } from '../../install/shared/services/storage.service';

@Component({
  selector: 'yi-reset-password',
  template: require('./reset_password.component.html'),
  styles: [require('./reset_password.component.scss')]
})

export class ResetPasswordComponent extends PasswordUpdaterBaseComponent implements OnInit {

  saveBtnText: string;
  protected eventName: string;

  constructor(
    protected userService: UserService,
    protected redCrossService: AnalyticsTrackingProvider,
    protected logger: LogService,
    protected toastr: ToastService,
    protected redirectService: RedirectService,
    protected translate: TranslateService,
    protected route: ActivatedRoute,
    protected authService: AuthService,
    protected store: Store<SignupState>,
    protected storageService: StorageService
  ) {
    super(toastr, redirectService, translate, route, authService, logger, store, userService, redCrossService, storageService);
    this.saveBtnText = 'SIGNUP.RESET_PASSWORD.BUTTON_TEXT';
    this.eventName = REDCRSS_EVENTS.PASSWORD_CHANGED;
  }

  ngOnInit() {
    this.redCrossService.page(REDCRSS_EVENTS.VIEWED_B2B_PAGE, {
      pageCategory: 'Reset Password',
      path: window.location.origin,
      url: window.location.href,
      appKey: this.route.snapshot.queryParams['app_key'],
      title: this.translate.instant('SIGNUP.RESET_PASSWORD.ACTIVATE_ACCOUNT')
    });
  }
}
